export const menuItems = [
  // {
  // id: "M0",
  // name: "Dashboard",
  // iconName: "dashboard",
  // url: "/dashboard",
  // },
  {
    id: "M1",
    name: "Onboarding",
    iconName: "onboarding",
    url: "/onboarding",
    subMenu: [
      {
        name: "Overview",
        url: "onboarding/overview",
      },
      {
        name: "New Request",
        url: "ssss",
        disabled: true,
      },
      // {
      // name: "report",
      // url: "onboarding/report",
      // },
    ],
  },

  {
    id: "M2",
    name: "Vehicles",
    iconName: "vehicles",
    url: "/add-vehicle/overview",
    subMenu: [
      // {
      // name: "Owned",
      // url: "/owned",
      // },
      // {
      // name: "Leased Vehicle",
      // url: "/leased-vehicle",
      // },
      // {
      // name: "Hired Vehicle",
      // url: "/hired-vehicle",
      // },
      {
        name: "Overview",
        url: "/add-vehicle/overview",
      },
    ],
  },

  {
    id: "M3",
    name: "HR",
    iconName: "hr",
    url: "/hr",
    subMenu: [
      {
        name: "Add New",
        url: "hr/overview?query=add-new",
        notHighlight: true,
      },
      {
        name: "Overview",
        url: "hr/overview",
      },
      {
        name: "Employee Headcount",
        url: "hr/employee-headcount",
      },
      {
        name: "Leave & Holiday Management",
        url: "hr/leave-holiday-management",
      },
    ],
  },

  // {
  // id: "M4",
  // name: "Clients",
  // iconName: "clients",
  // url: "/clients",
  // },
  {
    id: "M5",
    name: "Maintenance",
    iconName: "maintenance",
    url: "/maintenance",
    subMenu: [
      {
        name: "Maintenance",
        url: "maintenance/maintenance",
      },
      {
        name: "Vehicle Defect’s",
        url: "/maintenance/vehicle-defects",
      },
      {
        name: "Vehicle Checks",
        url: "/maintenance/vehicle-checks",
      },
      {
        name: "Breakdown's",
        url: "/maintenance/breakdowns",
      },
      {
        name: "Complete Maintenance",
        url: "/maintenance/complete-maintenance",
      },
      // {
      // name: "Accident",
      // url: "/maintenance/accident",
      // },
    ],
  },
  {
    id: "M6",
    name: "Finance",
    iconName: "finance",
    url: "/finance",
    subMenu: [
      {
        name: "Pending for Invoicing",
        url: "/finance/pending-for-invoicing",
      },
      {
        name: "Self Billing",
        url: "/finance/self-billing",
      },
      {
        name: "Overview",
        url: "/finance/overview",
      },
    ],
  },
  {
    id: "M7",
    name: "Jobs",
    iconName: "job",
    url: "/jobs",
    subMenu: [
      {
        name: "Create Job",
        url: "/jobs",
      },
      {
        name: "Search & Report ",
        url: "/jobs/search-reports",
      },
      {
        name: "Pending",
        url: "/jobs/pending",
      },
    ],
  },
  {
    id: "M8",
    name: "Customer Config",
    iconName: "customerConfig",
    url: "/customer-config",

    subMenu: [
      {
        name: "Overview",
        url: "/customer-config/overview",
      },
      {
        name: "Add New Customer",
        url: "/customer-config/new",
      },
      {
        name: "Fuel Surcharge",
        url: "/customer-config/fuel-surcharge",
      },
    ],
  },
  {
    id: "M9",
    name: "Subcontractor",
    iconName: "subcontractor",
    url: "/subcontractor",

    subMenu: [
      {
        name: "Dashboard",
        url: "/subcontractor/",
      },
    ],
  },

  {
    id: "M9",
    name: "File Export",
    iconName: "fileExport",
    url: "/file-export",
  },
  {
    id: "M10",
    name: "Report",
    iconName: "report",
    url: "/report",
    subMenu: [
      {
        name: "Health & Safety",
        url: "report/health-safety",
        notHighlight: true,
      },
      {
        name: "Others",
        url: "report/other/overview",
      },
      {
        name: "Night Out",
        url: "report/nightout",
      },
      {
        name: "Fuel up Dashboard",
        url: "report/fuel-up",
      },
      {
        name: "Expense Dashboard",
        url: "report/Expense",
      },
    ],
  },
  {
    id: "M11",
    name: "Planner",
    iconName: "planner",
    url: "/planner",
  },
  {
    id: "M12",
    name: "Tasks",
    iconName: "task",
    url: "/tasks",
  },
];
